import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import useGoogleMaps from "../../../Helpers/useGoogleMaps";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import car from "../../../Assets/images/car.png";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import moment from 'moment'
import BackButton from "../../../Components/BackButton";
import Handler from "../../../Helpers/Handler";
import { GoXCircle } from "react-icons/go";
import { BsArrowsAngleExpand } from "react-icons/bs";
import { BiSolidLockAlt, BiSolidLockOpenAlt } from "react-icons/bi";
import { PiToggleLeftDuotone, PiToggleRightFill } from "react-icons/pi";

const Device = () => {
    const { id } = useParams();
    const [render, setRender] = useState(false);
    const [mapLocation, setMapLocation] = useState([]);
    const [disable, setDisable] = useState(false)
    const [currentLocation, setCurrentLocation] = useState({ lat: 0, lng: 0 });
    const [showPolyline, setShowPolyline] = useState(false);
    const mapRef = useRef(null);
    const [validLocations, setValidLocations] = useState([])
    const [latestData, setLatestData] = useState(null);
    const [between, setBetween] = useState({ from: "", to: "" })
    const [state, setState] = useState("")
    const [offCan, setOffCan] = useState(true)
    const [show, setShow] = useState(true)
    const { isLoaded, loadError } = useGoogleMaps();
    const [showDatePicker, setShowDatePicker] = useState(false);
    const createRotatedIcon = (url, heading) => {
        const size = 40;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext('2d');

        const image = new Image();
        image.src = url;

        return new Promise((resolve) => {
            image.onload = () => {
                context.clearRect(0, 0, size, size);
                context.save();
                context.translate(size / 2, size / 2);
                context.rotate((heading * Math.PI) / 180);
                context.drawImage(image, -size / 2, -size / 2, size, size);
                context.restore();
                resolve(canvas.toDataURL());
            };
        });
    };
    const handleOpenDatePicker = () => {
        setShowDatePicker(true);
    };
    const handleCloseDatePicker = () => {
        setShowDatePicker(false);
    };
    const getDetail = async () => {
        setRender(true)
        const response = await Handler({ method: 'GET', url: `/staff/car/location/${id}` })
        if (response?.success) {
            const decryptedData = (response?.data)?.data
            setState(decryptedData?.state)
            setLatestData(decryptedData)
            setCurrentLocation({ lat: Number(decryptedData?.location?.latitude) || 12.963558107211364, lng: Number(decryptedData?.location?.longitude) || 80.16346985041018 })
            setMapLocation(decryptedData?.location ? decryptedData?.location : [{ latitude: 12.963558107211364, longitude: 80.16346985041018, altitude: 0, speed: 0, direction: 0, time: new Date() }]);
        } else {
            toast.error(response?.data?.message);
        }
        setRender(false)
    };
    const command = async (command) => {
        setDisable(true);
        setRender(true);
        const response = await Handler({ method: 'PATCH', url: `/staff/car/command/${id}`, data: { "command": command } })
        setRender(false);
        if (response?.success) {
            toast.success(command + ' Successful')
            if (command === "on" || command === "off") { setState(command) }
            setTimeout(() => {
                setDisable(false)
            }, 10000)
        } else {
            toast.error(response?.data?.message)
            setDisable(false)
        }
    }
    const submitDate = async () => {
        if (between?.to && between?.from) {
            setRender(true)
            handleCloseDatePicker();
            const response = await Handler({ method: 'POST', url: `/staff/car/history/${id}`, data: { startDate: between?.from, endDate: between?.to } })
            if (response?.success) {
                setRender(false)
                let location = (response?.data?.data && response?.data?.data?.length) && response?.data?.data?.map((loc) => ({
                    lat: parseFloat(Number(loc?.location?.coordinates[1])),
                    lng: parseFloat(Number(loc?.location?.coordinates[0])),
                })).filter((loc) => !isNaN(loc.lat) && !isNaN(loc.lng))
                setValidLocations(location);
                setShowPolyline(true)
            } else {
                toast.error(response?.data?.message)
                setRender(false)
            }
        } else {
            toast.error("Choose two dates")
        }
    }
    useEffect(() => {
        if (mapLocation.length) {
            let location = (mapLocation && mapLocation?.length) && mapLocation.map((loc) => ({
                lat: parseFloat(loc?.latitude),
                lng: parseFloat(loc?.longitude),
            })).filter((loc) => !isNaN(loc.lat) && !isNaN(loc.lng))
            setValidLocations(location)
        }
    }, [mapLocation]);

    useEffect(() => {
        const fetchDetails = () => {
            getDetail();
        };
        fetchDetails();
        const intervalId = setInterval(() => {
            if (showPolyline) {
                return;
            }
            fetchDetails();
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [id, showPolyline]);

    if (loadError) return <div>Error loading map</div>
    if (!isLoaded) return <div>Loading...</div>

    return render ? (
        <div style={{ height: 'calc(100vh - 120px)' }} className="d-flex align-items-center justify-content-center">
            ... Loading ...
        </div>
    ) : (
        <React.Fragment>
            <div className="container-fluid py-0">
                <div className="row">
                    <div className="col-12 mb-3" > <BackButton name="to View" /> </div>
                    <div className="map-view">
                        <GoogleMap mapContainerStyle={{ width: "100%", height: "100%", position: 'absolute' }} center={currentLocation} zoom={16} onLoad={(map) => (mapRef.current = map)}>
                            {showPolyline && validLocations.length > 0 && (
                                <Polyline
                                    path={validLocations}
                                    options={{
                                        strokeColor: "#f16436",
                                        strokeOpacity: 0.8,
                                        strokeWeight: 5
                                    }}
                                />
                            )}
                            {showPolyline && validLocations.length > 0 && validLocations[0] && (
                                <Marker
                                    position={validLocations[0]}
                                    onLoad={async (marker) => {
                                        if (window.google) {
                                            const rotatedIcon = await createRotatedIcon(car, latestData?.location?.direction);
                                            marker.setIcon({
                                                url: rotatedIcon,
                                                scaledSize: new window.google.maps.Size(30, 30),
                                                anchor: new window.google.maps.Point(15, 15),
                                            });
                                        }
                                    }}
                                />
                            )}
                            {showPolyline && validLocations.length > 0 && validLocations?.length !== 1 && (
                                <Marker
                                    position={validLocations[validLocations?.length - 1]}
                                />
                            )}
                            {(latestData && !showPolyline) ? (
                                <Marker
                                    position={currentLocation}
                                    onLoad={async (marker) => {
                                        if (window.google) {
                                            const rotatedIcon = await createRotatedIcon(car, latestData?.location?.direction);
                                            marker.setIcon({
                                                url: rotatedIcon,
                                                scaledSize: new window.google.maps.Size(30, 30),
                                                anchor: new window.google.maps.Point(15, 15),
                                            });
                                        }
                                    }}
                                />
                            ) : ""}
                        </GoogleMap>
                        <button className={`${offCan ? "d-none" : ""} btn offcan-btn`} onClick={() => setOffCan(true)}>Details</button>
                        <button className={`${show ? "d-none" : ""} btn offcan-btn button-theme`} onClick={() => setShow(true)}><BsArrowsAngleExpand /></button>
                        {show ? <div className="tracking-card">
                            <div className="d-flex align-items-center justify-content-between p-3 pb-0">
                                <h5 className="text-center fw-bold m-0">{id}</h5>
                                <button className="btn p-0" onClick={() => setShow(false)}><GoXCircle className=" fs-4 fw-bold" /></button>
                            </div>
                            <hr></hr>
                            <div className="px-3">
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Latitude </div>
                                    <div className="col-12 fw-light">{latestData?.location?.latitude || 12.963558107211364}</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Longitude</div>
                                    <div className="col-12 fw-light">{latestData?.location?.longitude || 80.16346985041018}</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Altitude </div>
                                    <div className="col-12 fw-light">{latestData?.location?.altitude || 0} m</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Speed </div>
                                    <div className="col-12 fw-light">{latestData?.location?.speed || 0} m/s</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Start KM </div>
                                    <div className="col-12 fw-light">{latestData?.startKm || 0} m/s</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Current KM </div>
                                    <div className="col-12 fw-light">{latestData?.currentKm || 0} m/s</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Direction </div>
                                    <div className="col-12 fw-light">{latestData?.location?.direction || 0}</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Engine Status </div>
                                    <div className="col-12 fw-light">{latestData?.engine ? "On" : "Off"}</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">Last Update </div>
                                    <div className="col-12 fw-light">{latestData?.lastUpdate ? moment(latestData?.lastUpdate)?.format("DD/MM/YYYY hh:mm A") : moment(new Date())?.format("DD/MM/YYYY hh:mm A")}</div>
                                </div>
                                <div className="deviceDetail my-2 row">
                                    <div className="col-12 fw-medium">History</div>
                                    <div className="col-12 fw-light">
                                        <button onClick={() => { showPolyline ? setShowPolyline(false) : handleOpenDatePicker() }} className="btn-sm btn-success btn" color="">
                                            {showPolyline ? "Hide" : "View"} Route
                                        </button>
                                    </div>
                                </div>
                                <div className="deviceDetail my-2 mb-3 row align-items-center">
                                    <div className="col-12 fw-medium">Events</div>
                                    <div className="col-12 fw-light">
                                        <div className="d-flex">
                                            <button outline className='btn-sm me-2 device-btns btn-danger btn' disabled={disable} onClick={() => { command("lock"); }}><BiSolidLockAlt /> Lock</button>
                                            <button outline className="btn-sm device-btns btn-success btn" disabled={disable} onClick={() => { command("unlock"); }}><BiSolidLockOpenAlt /> Unlock</button>
                                        </div>
                                        <div className="d-flex mt-2">
                                            {state !== "on" && <button outline className="btn-sm btn me-2 device-btns btn-success" disabled={disable} onClick={() => { command("on"); }}><PiToggleRightFill />On</button>}
                                            {state !== "off" && <button outline className="btn-sm btn device-btns btn-danger" disabled={disable} onClick={() => { command("off"); }}><PiToggleLeftDuotone /> Off</button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
                    </div>
                </div>
            </div>
            {showDatePicker && (
                <div className="datepicker-container">
                    <DatePicker
                        format="DD/MM/YYYY HH:mm"
                        range
                        dateSeparator=" to "
                        inputClass="form-control p-1"
                        plugins={[<TimePicker hideSeconds />]}
                        calendarPosition="bottom-center"
                        hideInput={true}
                        inline
                        onChange={(e) => {
                            if (e[0]) {
                                setBetween((prev) => ({ ...prev, from: new Date(e[0]) }))
                            }
                            if (e[1]) {
                                setBetween((prev) => ({ ...prev, to: new Date(e[1]) }))
                            }
                        }}
                        maxDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                    />
                    <button className="btn-sm btn-success btn" onClick={() => { submitDate() }}>Submit</button>
                    <button className="btn-sm btn-danger btn" onClick={() => { handleCloseDatePicker() }}>Cancel</button>
                </div>
            )}
        </React.Fragment>
    );
};

export default Device;